import styled from 'styled-components';
import { motion } from 'framer-motion';
import * as Text from 'theme/components/Text.style';

export const Container = styled(motion.div)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 65px;
  pointer-events: none;
  position: absolute;
  right: 65px;
  top: 0;
  bottom: 0;
  overflow: hidden;
`;

export const Title = styled(Text.P2Semibold)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-align: center;
`;

export const Subtitle = styled(Text.Label)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-align: center;
`;
